import { render, staticRenderFns } from "./WordListTable.vue?vue&type=template&id=a1119998&scoped=true&lang=html&"
import script from "./WordListTable.vue?vue&type=script&lang=js&"
export * from "./WordListTable.vue?vue&type=script&lang=js&"
import style0 from "./WordListTable.vue?vue&type=style&index=0&id=a1119998&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1119998",
  null
  
)

export default component.exports